package nl.volleyplanner.api.client

import io.ktor.client.engine.*
import io.ktor.client.engine.js.*

actual val apiEngine: HttpClientEngine = Js.create()
